import {
  createClientPayment as APICreateClientPayment,
  updateClientPayment as APIUpdateClientPayment,
  getClientPayments as APIGetClientPayments,
  deleteClientPayment as APIDeleteClientPayment,
  getClientPaymentsDraft as APIGetClientPaymentsDraft,
  confirmClientPayments as APIConfirmClientPayments,
} from "API/swesum";
import { createContext, useContext, useState } from "react";

const ClientPaymentsContext = createContext(null);

export const ClientPaymentsContextProvider = ({ children }) => {
  const [clientPayments, setClientPayments] = useState([]);
  const [paymentNumber, setPaymentNumber] = useState(null);
  const [loading, setLoading] = useState(false);

  const getClientPayments = async () => {
    setLoading(true);
    const data = await APIGetClientPayments();
    setClientPayments(data);
    setLoading(false);
  };

  const getClientPaymentsDraft = async () => {
    setLoading(true);
    const data = await APIGetClientPaymentsDraft();
    setClientPayments(data.ClientPayments);
    setPaymentNumber(data.PaymentNumber);
    setLoading(false);
  };

  const confirmClientPayments = async (ids) => {
    setLoading(true);
    let res = null;
    if (ids.length > 0) {
      res = await APIConfirmClientPayments(ids);
    }
    setLoading(false);
    return res;
  };

  const getClientPaymentById = (clientPaymentId) => {
    return clientPayments.find(
      (clientPayment) => clientPayment.Id == clientPaymentId
    );
  };

  const createClientPayment = async (data) => {
    setLoading(true);
    const res = await APICreateClientPayment(data);
    setClientPayments((prevClientPayments) => [
      ...prevClientPayments,
      res.data,
    ]);
    setLoading(false);
    return res;
  };

  const updateClientPayment = async (clientPaymentId, body) => {
    const res = await APIUpdateClientPayment(clientPaymentId, body);
    const updatedClientPayment = res.data;
    if (res.status === 201) {
      setClientPayments((currentClientPayments) =>
        currentClientPayments.map((clientPayment) =>
          clientPayment.Id === updatedClientPayment.Id
            ? { ...clientPayment, ...updatedClientPayment }
            : clientPayment
        )
      );
    }
    return res;
  };

  const deleteClientPayment = async (clientPaymentId) => {
    const res = await APIDeleteClientPayment(clientPaymentId);
    if (res.status === 201) {
      const updatedClientPayments = clientPayments.filter(
        (clientPayment) => clientPayment.Id !== clientPaymentId
      );
      setClientPayments(updatedClientPayments);
    }
    return res;
  };

  const refreshClientPayments = () => {
    getClientPayments();
  };

  return (
    <ClientPaymentsContext.Provider
      value={{
        clientPayments,
        paymentNumber,
        createClientPayment,
        confirmClientPayments,
        getClientPaymentById,
        getClientPayments,
        getClientPaymentsDraft,
        updateClientPayment,
        refreshClientPayments,
        deleteClientPayment,
        loading,
      }}
    >
      {children}
    </ClientPaymentsContext.Provider>
  );
};

export const useClientPayments = () => useContext(ClientPaymentsContext);
